/**
 * Derives member attribute values from customer_attributes (CONVE, CONV_ND)
 * These values should match what the backend uses in product.member_attribute_availability
 * 
 * @param {Array} customerAttributes - Array of {id, value} objects from lsAccount.customer_attributes
 * @returns {Array<string>} Array of member attribute codes (e.g. ["BUS"], ["QRCODE"], ["BUS", "QRCODE"])
 */
export const deriveMemberAttributes = customerAttributes => {
  if (!customerAttributes || !Array.isArray(customerAttributes)) {
    return [];
  }
  const memberAttributes = [];

  // CONVE: Direct value (BUS, UNI, WAO, VIP, etc.)
  const conveAttribute = customerAttributes.find(attr => attr.id === "CONVE");
  if (conveAttribute !== null && conveAttribute !== void 0 && conveAttribute.value) {
    memberAttributes.push(conveAttribute.value);
  }

  // CONV_ND: Maps to "QRCODE" member attribute
  const convNdAttribute = customerAttributes.find(attr => attr.id === "CONV_ND");
  if (convNdAttribute !== null && convNdAttribute !== void 0 && convNdAttribute.value) {
    memberAttributes.push("QRCODE");
  }
  return memberAttributes;
};
export const getPrimaryConvenzioneCode = customerAttributes => deriveMemberAttributes(customerAttributes)[0] || null;